import React, { useState } from 'react';
import LocationList from './LocationList';
import AddLocationForm from './AddLocationForm';
import { Box } from '@mui/material';

function LocationManager() {
  const [locations, setLocations] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const addLocation = (location) => {

    if (!location.name || location.name.trim() === '') {
      return;
    }

    setLocations((prevLocations) => [...prevLocations, location]);
    setShowForm(false);
  };

  const toggleForm = () => {
    setShowForm((prevShowForm) => !prevShowForm);
  };

  return (
    <Box sx={{ padding: 2 }}>
      {showForm ? (
        <AddLocationForm
          addLocation={addLocation}
          toggleForm={toggleForm}
          id="addlocationform"
          name="addLocationForm"
        />
      ) : (
        <LocationList
          locations={locations}
          toggleForm={toggleForm}
          id="locationlist"
          name="locationList"
        />
      )}

    </Box>
  );
}

export default LocationManager;




